module.exports = __webpack_public_path__ + "static/media/BG.abeb6bac.png";